import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import styles from '../RevenueVendorExpenseTable.module.scss';
import LoadingSpinner from '../../../../../../common/_custom/LoadingSpinner/LoadingSpinner';
import Button from '../../../../../../common/_custom/Button/Button';
import MsmeDelayDrawer from '../../../../components/Graph/components/MsmeDelay/MsmeDelayDrawer';
import type { MsmeDelayGraph } from '../../../../../../store/dashboard/compliancesBefe/types';
import { loadMsmeDelayGraph } from '../../../../../../store/dashboard/compliancesBefe/msmeDelayGraphCache';
import OpenMuOrgIcon from '../../../../../../assets/Svg/OpenMUOrgIcon';
import { MSME_DELAY_LOAD_ERROR, MSME_DELAY_TAG_LABEL, msmeDelayTagAriaLabel } from './overlap.constants';

/** Red "MSME Delay" pill; a click opens the MSME drawer with this vendor's supplier row highlighted. */
const MsmeDelayTag = ({ pan, vendorName }: { pan: string; vendorName: string }) => {
    const orgId = useParams().id;
    const [graphData, setGraphData] = useState<MsmeDelayGraph | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const isMountedRef = useRef(true);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const openDrawer = async () => {
        if (!orgId) return;
        setIsLoading(true);
        const graph = await loadMsmeDelayGraph(orgId);
        if (!isMountedRef.current) return;
        setIsLoading(false);
        if (!graph) {
            toast.error(MSME_DELAY_LOAD_ERROR);
            return;
        }
        setGraphData(graph);
    };

    return (
        <>
            <Button
                type="button"
                className={styles.MsmeDelayTag}
                onClick={openDrawer}
                disabled={isLoading}
                aria-busy={isLoading}
                aria-label={msmeDelayTagAriaLabel(vendorName)}
                text={MSME_DELAY_TAG_LABEL}
                icon={
                    isLoading ? (
                        <LoadingSpinner height="0.75rem" color="var(--risk-indicator-red)" className={styles.MsmeDelayTagIcon} />
                    ) : (
                        <span className={styles.MsmeDelayTagIcon} aria-hidden="true">
                            <OpenMuOrgIcon colour="currentColor" width="100%" height="100%" />
                        </span>
                    )
                }
            />
            {graphData && <MsmeDelayDrawer graphData={graphData} highlightPan={pan} onClose={() => setGraphData(null)} />}
        </>
    );
};

export default MsmeDelayTag;
